/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'all': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.21 17.16',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M4.13 0a4.13 4.13 0 104.13 4.13A4.14 4.14 0 004.13 0zm0 7.26a3.13 3.13 0 113.13-3.13 3.13 3.13 0 01-3.13 3.13zM13.08 0a4.13 4.13 0 104.13 4.13A4.14 4.14 0 0013.08 0zm0 7.26a3.13 3.13 0 113.13-3.13 3.14 3.14 0 01-3.13 3.13zM4.13 8.9A4.13 4.13 0 108.26 13a4.14 4.14 0 00-4.13-4.1zm0 7.26A3.13 3.13 0 117.26 13a3.13 3.13 0 01-3.13 3.16z" _fill="#c4c4c4"/><circle pid="1" cx="13.08" cy="13.03" r="3.63" _fill="#74777a"/></g></g>'
  }
})
